// src/api/caseType.api.js

import api from './axios';

export const getCaseTypesApi = (page = 1, limit = 10, q = '') =>
    api.get('/case/setting/caseType', { params: { page, limit, q } });

export const createCaseTypeApi = (payload) =>
    api.post('/case/setting/caseType', payload);

export const updateCaseTypeApi = (caseTypeId, payload) =>
    api.put(`/case/setting/caseType/${caseTypeId}`, payload);

export const deleteCaseTypeApi = (caseTypeId) =>
    api.delete(`/case/setting/caseType/${caseTypeId}`);
